import React from 'react'
import { Link } from 'react-router-dom'
import wad from '../../../../assets/img/csd_mn.webp'
import './Wadhead.css'
import ContactForm from '../../Contact/ContactForm'

function Wadhead() {
  return (
    <section className='hmslder-sec serhead-sec'>
        <div className='breadcrumbs'>
            <div className='container'>
             <ul>
               <li><Link to='/'>Home</Link></li> 
               <li><Link to='/Service'>Services</Link></li>  
               <li>Custom Software Development</li>   
             </ul> 
             </div> 
        </div>
        <div className='container'>
           <div className='hmslder-txt'>
              <h2>Trusted Custom Software Development Partner. <span>Build software that fits your business</span>, not the other way around </h2>
              <p>At 360 Bytes, we design and develop custom software solutions that map directly to your business processes, goals, and user journeys. From industry-specific platforms to complex internal systems, our solutions are built for performance, security, and scale to help you operate smarter and faster.              </p>
            </div> 
            <ContactForm thankYouSource="custom-software-development" />
           {/* <div className='hmslder-img'>
            <img src={wad} alt='Custom Software Development' width={1200} height={800} loading="lazy" />
            </div>   */}
        </div>
    </section>
  )
}

export default Wadhead
